import { render, staticRenderFns } from "./GigAddEdit.htm?vue&type=template&id=3d8a2b2a&scoped=true&"
import script from "./GigAddEdit.ts?vue&type=script&lang=js&"
export * from "./GigAddEdit.ts?vue&type=script&lang=js&"
import style0 from "./GigAddEdit.scss?vue&type=style&index=0&id=3d8a2b2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8a2b2a",
  null
  
)

export default component.exports